export default __webpack_public_path__ + "static/stage-2_2-d7b1a5062b821b12a8ddeabd7c0176c6.jpg";